/** InsCoder WANG.J 2026-09-30 B + Keep the selected prong style across product and cart-edit flows. **/
(function(window, document) {
  'use strict';

  var propertyName = 'properties[Prongs]';
  var defaultValue = 'Rounded Prongs';

  function normalizeValue(value) {
    var normalized = String(value || '').trim().toLowerCase();
    if (normalized === 'eagle' || normalized === 'eagle claw' || normalized === 'eagle claw prongs') {
      return 'Eagle Claw Prongs';
    }
    if (normalized === 'rounded' || normalized === 'rounded prongs') {
      return defaultValue;
    }
    return value || defaultValue;
  }

  function getInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('input[name="' + propertyName + '"]'));
  }

  function getSelection() {
    var selected = getInputs().filter(function(input) { return input.checked; })[0];
    return selected ? selected.value : defaultValue;
  }

  function hydrateFromUrl() {
    var requestedValue = normalizeValue(new URLSearchParams(window.location.search).get('prongs'));
    var matchedInput = getInputs().filter(function(input) {
      return input.value === requestedValue;
    })[0];

    if (!matchedInput) {
      return;
    }

    getInputs().forEach(function(input) {
      input.checked = input === matchedInput;
    });
  }

  function initialize() {
    if (!getInputs().length) {
      return;
    }
    hydrateFromUrl();
  }

  window.KavalriProngStyle = {
    getSelection: getSelection,
    normalizeValue: normalizeValue
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})(window, document);
/** InsCoder WANG.J 2026-09-30 E + Keep the selected prong style across product and cart-edit flows. **/
